var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** A deliberate override — `TEMPLATE_OVERRIDE` with a `labelScope`. Shown, not counted as wrong. */
export var SCOPED_OVERRIDE = 'SCOPED_OVERRIDE';
/** `TEMPLATE_OVERRIDE` that records no reason — the override the tally must surface. */
export var UNSCOPED_OVERRIDE = 'UNSCOPED_OVERRIDE';
/** Any field with at least one discrepancy — the tile's headline number. */
export var ANY_DISCREPANCY = 'ANY_DISCREPANCY';
/** Discrepancy kinds, in the order the tile lists them (most actionable first). */
export var DISCREPANCY_KINDS = [
    'TEMPLATE_REDUNDANT',
    'ONTOLOGY_MISSING',
    'TEMPLATE_BLANK',
    'NO_LABEL_ANYWHERE',
    UNSCOPED_OVERRIDE,
];
var NOT_A_DISCREPANCY = new Set(['ONTOLOGY', 'FORM_ONLY']);
/**
 * Is this one trace row a discrepancy between the template and the ontology? The
 * row-level twin of the per-field counts below — same rule, so a field the tile
 * lists always opens onto at least one row this returns true for.
 */
export var isDiscrepancySource = function (row) {
    if (NOT_A_DISCREPANCY.has(row.source))
        return false;
    if (row.source === 'TEMPLATE_OVERRIDE')
        return !row.labelScope;
    return true;
};
/** How many of one field's rows fall into each discrepancy kind. */
var kindCounts = function (field) {
    var _a;
    var _b, _c, _d, _e, _f, _g;
    return (_a = {
            TEMPLATE_REDUNDANT: (_b = field.summary.TEMPLATE_REDUNDANT) !== null && _b !== void 0 ? _b : 0,
            ONTOLOGY_MISSING: (_c = field.summary.ONTOLOGY_MISSING) !== null && _c !== void 0 ? _c : 0,
            TEMPLATE_BLANK: (_d = field.summary.TEMPLATE_BLANK) !== null && _d !== void 0 ? _d : 0,
            NO_LABEL_ANYWHERE: (_e = field.summary.NO_LABEL_ANYWHERE) !== null && _e !== void 0 ? _e : 0
        },
        // Never negative even if a malformed response claims more scoped than total.
        _a[UNSCOPED_OVERRIDE] = Math.max(0, ((_f = field.summary.TEMPLATE_OVERRIDE) !== null && _f !== void 0 ? _f : 0) - ((_g = field.scopedOverrides) !== null && _g !== void 0 ? _g : 0)),
        _a);
};
/** Does this field fall into this bucket? */
export var fieldInBucket = function (field, bucket) {
    var _a;
    if (!field)
        return false;
    if (bucket === SCOPED_OVERRIDE)
        return ((_a = field.scopedOverrides) !== null && _a !== void 0 ? _a : 0) > 0;
    var counts = kindCounts(field);
    if (bucket === ANY_DISCREPANCY)
        return DISCREPANCY_KINDS.some(function (kind) { return counts[kind] > 0; });
    return counts[bucket] > 0;
};
/**
 * Number of FIELDS per bucket, not rows: the question is "where", and a field with
 * eight overridden 024 occurrences is one place to look, not eight. A field may be in
 * several kinds at once, so the kinds do not sum to the headline.
 */
export var bucketFieldCounts = function (summary) {
    var _a;
    var _b;
    var counts = __assign((_a = {}, _a[ANY_DISCREPANCY] = 0, _a[SCOPED_OVERRIDE] = 0, _a), Object.fromEntries(DISCREPANCY_KINDS.map(function (kind) { return [kind, 0]; })));
    Object.values((_b = summary === null || summary === void 0 ? void 0 : summary.fields) !== null && _b !== void 0 ? _b : {}).forEach(function (field) {
        Object.keys(counts).forEach(function (bucket) {
            if (fieldInBucket(field, bucket))
                counts[bucket] += 1;
        });
    });
    return counts;
};
